// extracted by mini-css-extract-plugin
export default {"project":"Project_project__wMKnd","project-text":"Project_project-text__VxqrJ"};